import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Appointments = lazy(() => import('./appointments'));

export function AppointmentsPage() {
  return (
    <article className="space-y-6" data-testid="appointments-page">
      <Suspense fallback={<Loading />}>
        <Appointments />
      </Suspense>
    </article>
  );
}
